import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useFormsContext } from 'pages/forms/context/FormsProvider';
import { useStyles } from './styles';
import { InjectedRouter } from 'react-router';
import { IconButton } from '@material-ui/core';

interface IProps {
  rowIndex: number;
  router: InjectedRouter;
}

export const AnswerFormButton = ({ rowIndex, router }: IProps) => {
  const { data } = useFormsContext();
  const styles = useStyles();

  const rowData = useMemo(() => {
    return data[rowIndex];
  }, [data, rowIndex]);

  const isButtonEnabled = useMemo(() => {
    return rowData.inPublished === 'S';
  }, [rowData]);

  const handleAnswer = () => {
    router.push(`/formularios/responder/${rowData.idForm}`);
  };

  return (
    <IconButton disabled={!isButtonEnabled} onClick={handleAnswer} className={styles.button}>
      <FontAwesomeIcon icon={faArrowRight} />
    </IconButton>
  );
};
